// extracted by mini-css-extract-plugin
export default {"no_wrap":"no_wrap__1PxEe"};